import { useInView } from 'react-intersection-observer';

type Options = {
    hasNextPage: boolean;
    isLoading: boolean;
    isFetchingNextPage: boolean;
    fetchNextPage: () => unknown;
};

/**
 * Ref for a sentinel after the last item: fetches the next page when it scrolls
 * into view. Key the sentinel by page count so it remounts with every page, and a
 * page that still leaves it in view fetches the one after.
 */
export function useLoadMoreRef({
    hasNextPage,
    isLoading,
    isFetchingNextPage,
    fetchNextPage,
}: Options): (node?: Element | null) => void {
    const [ref] = useInView({
        onChange: (inView) => {
            if (inView && hasNextPage) {
                void fetchNextPage();
            }
        },
        skip: isLoading || isFetchingNextPage,
    });

    return ref;
}
